<div mat-dialog-title class="p-3">
  <h5>
    Add/Update Time Onsite Record
    <button mat-icon-button class="float-right" mat-dialog-close>
      <mat-icon color="secondary">close</mat-icon>
    </button>
  </h5>
</div>

<mat-dialog-content class="p-3">
  <form #f="ngForm" (ngSubmit)="onSave(f)">

    <div class="row m-0 mb-3">
      <div class="col">

        <h3>Required</h3>

        <button
          mat-raised-button
          class="mr-3 mb-3 custom-button-width"
          type="button"
          color="secondary"
          id="site_selector_button"
          (click)="onSelectSites()"
          [matBadge]="timeOnsiteRecord.site_id != 0 ? 'Y' : 'N'"
          matTooltip="Select the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} this record is intended for.">
          Select a {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
        </button>

        <app-datetime-picker
          [selectedDateTime]="recordDateTime"
          [isDisabled]="!timeOnsiteRecord.site_id"
          [pickerName]="'recordDateTime'"
          [label]="'Select a date and/or time:'"
          [hint]="'Click the calendar icon to select a date/time.'"
          [selectTooltip]="'Select the date/time.'"
          [removeTooltip]="'Remove the selected date/time.'"
          [classes]="'full-width mb-3'"
          (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>

        <mat-form-field class="full-width mb-3">
          <mat-label>Enter the duration (of the visit) in hours:</mat-label>
          <input
            matInput
            placeholder="Duration in hours e.g. 6."
            [(ngModel)]="timeOnsiteRecord.duration_in_hours"
            name="duration_in_hours"
            type="number"
            id="duration_in_hours"
            [disabled]="!timeOnsiteRecord.site_id || !recordDateTime"
            required/>
          <mat-hint>Enter the duration in hours e.g. 6.</mat-hint>
        </mat-form-field>

      </div>

      <div class="col">

        <h3>Optional</h3>

        <div class="row mb-3">
          <div class="col">
            <button
              mat-raised-button
              class="mr-3 custom-button-width"
              type="button"
              color="secondary"
              id="account_selector_button"
              (click)="onSelectAccounts()"
              [disabled]="!timeOnsiteRecord.site_id || !recordDateTime"
              [matBadge]="timeOnsiteRecord.user_account_id != 0 ? 'Y' : 'N'"
              matTooltip="Select the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} this record is intended for.">
              Select an existing {{ utils.getLangTerm('contractors.singular', 'Contractor') }}
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <button
              mat-raised-button
              class="mr-3 custom-button-width"
              type="button"
              color="secondary"
              id="account_creator_button"
              (click)="onAddAccount()"
              [disabled]="!timeOnsiteRecord.site_id || !recordDateTime"
              [matBadge]="timeOnsiteRecord.user_account_id != 0 ? 'Y' : 'N'"
              matTooltip="Add the {{ utils.getLangTerm('contractors.singular', 'Contractor') }} this record is intended for.">
              Add a new {{ utils.getLangTerm('contractors.singular', 'Contractor') }}
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <button
              mat-raised-button
              class="mr-3 custom-button-width"
              type="button"
              color="secondary"
              id="user_selector_button"
              (click)="onSelectUsers()"
              [disabled]="!timeOnsiteRecord.site_id || !recordDateTime"
              [matBadge]="timeOnsiteRecord.user_id != 0 ? 'Y' : 'N'"
              matTooltip="Select the user this record is intended for.">
              Select an existing user
            </button>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <button
              mat-raised-button
              class="mr-3 custom-button-width"
              type="button"
              color="secondary"
              id="user_creator_button"
              (click)="onAddUser()"
              [disabled]="!timeOnsiteRecord.site_id || !recordDateTime"
              [matBadge]="timeOnsiteRecord.user_id != 0 ? 'Y' : 'N'"
              matTooltip="Select the user this record is intended for.">
              Add a new user ({{ utils.getLangTerm('employees.singular', 'Employee') }})
            </button>
          </div>
        </div>

      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button type="button" (click)="onSave(f)" [disabled]="!f.valid" color="primary">Save</button>
</mat-dialog-actions>
